export default __webpack_public_path__ + "static/media/Maharaja09.1b6ce3c4.jpg";